import { TranslationService } from '../../../../../services/translation.service';
import { createElementHook, createControlHook, createLeafComponent } from '@react-leaflet/core';
import type { LeafletContextInterface } from '@react-leaflet/core';
import { ControlPosition } from 'leaflet';
import L from 'leaflet';

interface FilterControlProps {
  className: string;
  position?: ControlPosition;
  onClick?: () => void;
}

function createFilterControl({ className, position = 'bottomright', onClick }: FilterControlProps, context: LeafletContextInterface) {
  const controlInstance = new L.Control({ position });

  controlInstance.onAdd = () => {
    const div = L.DomUtil.create('div', `leaflet-bar ${className ?? ''}`);
    const hyperlink = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single');
    hyperlink.href = '#';
    hyperlink.title = TranslationService.get('common.map.togglefilters');
    hyperlink.setAttribute('role', 'button');
    hyperlink.setAttribute('aria-label', TranslationService.get('common.map.togglefilters'));
    hyperlink.onclick = (e) => {
      e.preventDefault();
      onClick?.();
    };
    hyperlink.innerHTML = '<span aria-hidden="true" class="leaflet-control-filter-icon"></span>';
    div.appendChild(hyperlink);
    return div;
  };

  return { instance: controlInstance, context };
}

function updateFilterControl(instance: L.Control, props: FilterControlProps, prevProps: FilterControlProps) {
  if (props.className === prevProps.className) return;
  const container = instance.getContainer();
  if (!container) return;
  const prev = prevProps.className?.split(' ').filter(Boolean) ?? [];
  const next = props.className?.split(' ').filter(Boolean) ?? [];
  if (prev.length) container.classList.remove(...prev);
  if (next.length) container.classList.add(...next);
}

const useFilterControlElement = createElementHook(createFilterControl, updateFilterControl);
const useFilterControl = createControlHook(useFilterControlElement);
const FilterControlComponent = createLeafComponent(useFilterControl);

export default FilterControlComponent;
